import { ReactNode } from 'react';

import { Typography } from '@mui/material';

import styled from 'styled-components';

interface PropertyDetailsTextSectionProps {
  text: ReactNode;
  title: ReactNode;
}

const StyledPropertyDetailsTextSection = styled.div`
  &.property-details-text-section-wrapper {
    .property-details-text-section-text {
      margin: ${(props) => props.theme.spacing(2, 0)};
    }
  }
`;

export const PropertyDetailsTextSection = (props: PropertyDetailsTextSectionProps) => {
  const { text, title } = props;

  return (
    <StyledPropertyDetailsTextSection className="property-details-text-section-wrapper">
      <Typography variant="h4.semibold" className="property-details-text-section-title">
        {title}
      </Typography>
      <Typography variant="body1" className="property-details-text-section-text">
        {text}
      </Typography>
    </StyledPropertyDetailsTextSection>
  );
};
